import api from './api';
import { OptionProps } from '@digital/ui';


export const getAllTipoProjetoFase = () => api.get<any[]>('status/getAllTipoProjetoFase');

export const getAllTipoProjetoFaseOptions = () => {
  return getAllTipoProjetoFase().then(Tipo =>
    (Tipo || []).map(t => ({ text: t.nome, value: t.id.toString() } as OptionProps)),
  );
}
